import React from 'react';
import UserAvatar from '../common/UserAvatar';

const tableConfig = (props) => ({
    columns: [
        { 
            title: 'Category Name', field: 'category.category_name', filterAndSearch: true
        },
        { 
            title: 'SubCategory Name', field: 'sub_category_name', filterAndSearch: true
        },
        { 
            title: 'SubCategory Status', field: 'status', status: false, filterAndSearch: false, width: "150px",
            render: rowData => <div>
                {rowData.status == 1 ? 'active' : 'In active'}
            </div>
        },
         
    ],
})

export default tableConfig;